import styled from '@emotion/styled';
import { Modal, tokens } from '@hotjar/hotsauce';

export const S = {
  ModalBody: styled(Modal.Body)`
    overflow: initial;
    padding-left: 0;
    padding-right: 0;
    display: flex;
    flex-direction: column;
  `,
  PlanChangeListContainer: styled.div`
    overflow: auto;
    padding: 0 ${tokens.spacer.x3};
  `,
};
